module.exports = __webpack_public_path__ + "img/ydcx.png";